// extracted by mini-css-extract-plugin
export default {"root":"_29_GMk-iGf9lGKVjs2p1v1","logoContainer":"zdd_gRjZrV0tKgsAwmhOV","ssoButtons":"HHoYJPbZ7WO148F2vOVAp","whatIsCausemos":"_2hOot-9RMMnw6IxnHjHNqr"};